import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { BusinessFleetInsuranceMetadata } from 'src/app/_types/lead.types';
import { InsuranceType } from 'src/app/enums/insurance-type.enum';
import {
  BUSINESS_INSURANCE_PAYMENT_FREQUENCY,
  getPaymentFrequencyLabel,
} from 'src/app/enums/payment-frequency.enum';

import { LeadFormBase } from '../../lead-form-base';

@Component({
  selector: 'app-business-fleet-form',
  templateUrl: './business-fleet-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class BusinessFleetFormComponent
  extends LeadFormBase
  implements OnDestroy
{
  @Input()
  formGroup!: FormGroup;

  hasClaimsSub!: Subscription;

  constructor(private readonly fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.BUSINESS_FLEET,
    startDate: [null],
    contractDuration: [null],
    paymentFrequency: [null],
    splitPaymentFee: [null],
    hasclaimsLastFiveYears: [null],
    claims: [null],

    categoryOne: [null],

    civilResponsability: this.fb.group({
      civilResponsability: [null],
      bonusProtection: [null],
      seriousMisconductWaiver: [null],
      deductible: [null],
    }),

    casco: this.fb.group({
      cascoCollision: [null],
      bonusProtection: [null],
      seriousMisconductWaiver: [null],
      deductible: [null],
      partialCasco: [null],
      theftDeductible: [null],
      xenonLedHeadlightsCoverage: [null],
      travelEffects: [null],
      swissEuAssistance: [null],
      replacementVehicle: [null],
      crossLiability: [null],
      partialCascoDeductible: [null],
      cascoParc: [null],
      cascoParcDeductible: [null],
      bodyworkFreeChoice: [null],
    }),

    occupantsAccidents: this.fb.group({
      occupantsAccidents: [null],
      deathBenefit: [null],
      disabilityCapital: [null],
      dailyAllowance: [null],
      hospitalisationAllowance: [null],
      unlimitedTreatmentFee: [null],
    }),
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) {
      this.metadataFormGroup.patchValue(this.metadata);
      const fleetMetadata = this.metadata as BusinessFleetInsuranceMetadata;
      if (fleetMetadata.civilResponsability) {
        this.metadataFormGroup.controls['civilResponsability'].patchValue(
          fleetMetadata.civilResponsability
        );
      }
      if (fleetMetadata.casco) {
        this.metadataFormGroup.controls['casco'].patchValue(
          fleetMetadata.casco
        );
      }
      if (fleetMetadata.occupantsAccidents) {
        this.metadataFormGroup.controls['occupantsAccidents'].patchValue(
          fleetMetadata.occupantsAccidents
        );
      }
    }
    this.formGroup.addControl('metadata', this.metadataFormGroup);

    this.hasClaimsSub = this.metadataFormGroup.controls[
      'hasclaimsLastFiveYears'
    ].valueChanges.subscribe((value) => {
      if (value !== 'true' && value !== true) {
        this.metadataFormGroup.controls['claims'].reset();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.hasClaimsSub) this.hasClaimsSub.unsubscribe();
  }

  paymentFrequencyValues = BUSINESS_INSURANCE_PAYMENT_FREQUENCY;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;
}
